import {userAPI} from "~/api/userAPI";
import {TagAuth} from "~/constants/Tags";

export const enhancedUserAPI = userAPI.enhanceEndpoints({
    addTagTypes: [TagAuth],
    endpoints: {
        getUserByUserId: {providesTags: (_r, _e, arg) => [{type: TagAuth, id: arg}]},
        getUserCurrent: {
            providesTags: () => [{type: TagAuth, id: "current"}],
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (e){
                    const err = e as {error?: {status?: number}};
                    if (err.error && err.error.status === 401) {
                        dispatch(enhancedUserAPI.util.invalidateTags([TagAuth]));
                    }
                }
            },
        },
    }
});

export const {
    useGetUserQuery,
    useLazyGetUserQuery,
    useGetUserCurrentQuery,
    useLazyGetUserCurrentQuery,
    usePutUserCurrentMutation,
    useGetUserByUserIdQuery,
    useLazyGetUserByUserIdQuery,
    usePutUserByUserIdMutation,
} = enhancedUserAPI;